import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Components/Home/Home';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './Components/Footer/Footer';
import Navbars from './Components/Navbar/Navbars';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import { useEffect } from 'react';
// ..
AOS.init();

function App() {

  useEffect(() => {
    let domain = window.location.origin;
    console.log(domain);
    // window.location.replace('/home#banner');
    // Change the URL in the address bar to "/new-url"
    window.history.pushState({}, "", "/home#banner");




  }, [])
  return (
    <div className='overflow-hidden'>
      <Navbars></Navbars>
      <Home></Home>
      <ToastContainer />
      <Footer></Footer>
    </div>
  );
}

export default App;
